import { render, staticRenderFns } from "./GridView.vue?vue&type=template&id=56356c2c&scoped=true&"
import script from "./GridView.vue?vue&type=script&lang=js&"
export * from "./GridView.vue?vue&type=script&lang=js&"
import style0 from "./GridView.vue?vue&type=style&index=0&id=56356c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56356c2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
